import {gql} from "@apollo/client";
import {OrderType} from "../../../../../graphql/types/OrderType";
import {OrderFiltersType} from "../../../../../graphql/types/OrderFiltersType";

export const ORDER_FIELDS = `
    id
    securityRnd
    trackingNumber
    externalTrackingNumber
    channelId
    channelOrderNumber
    orderTime
    overallStatus
    isDelivered
    isIntercepted
    isAbnormal
    exceptionStatus
    isHasBeenSetException
    expectedDeliveryTime
    deliveredAt
    lastDeliveryScanTime
    deliveryAttempts
    exceptionReasonCode
    markExceptionAt
    nextAction
    senderAddressId
    recipientAddressId
    receiverZipcode
    sortingCode
    weightKg
    volumetricWeightKg
    lengthCm
    widthCm
    heightCm
    packageValueUsd
    podReviewStatus
    podImageS3KeysJson
    podImageS3UrlsJson
    exceptionImageS3KeysJson
    exceptionImageS3UrlsJson
    nextAction
    exceptionHubId
    exceptionWarehouseId
    isDestHubArrived
    isDestWarehouseArrived
    destHubArrivedAt
    destWarehouseArrivedAt
    receivedAtHub
    deliverAt
    isComplaint
    hasManded
    isFinished
    createdAt
    updatedAt
    lastBagTaskId
    bagTaskNumber
    prePickupHubName
    pickupHubName
    deliveredDspId
    returnArrivalHubAt
`;

export const GET_ORDER_LISTING_FOR_CENTRAL = gql`
    query CentralQuery($filters: OrderFiltersTypeInput,
                       $pageRequest: PageRequestTypeInput) {
        getOrderListingForPickupParcels(filters: $filters, pageRequest: $pageRequest) {
            content{
                ${ORDER_FIELDS}
                recipientAddress {
                    id
                    fullName
                    countryCode
                    phoneNumber
                    addressLine1
                    addressLine2
                    city
                    state
                    zipcode
                    company
                    instructions
                }
            }
            page
            size
            totalElements
            totalPages
            accessiblePages
            hasNext
            hasPrevious
        }
    }
`;

export interface CentralOrderListResponse {
    getOrderListingForPickupParcels: OrderListingResponseType;
}

export interface OrderListingResponseType {
    content: OrderType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    accessiblePages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

interface GetOrderListingForCentralInput {
    filters?: OrderFiltersType;
    pageRequest?: PageRequestType;
}

interface PageRequestType {
    page: number;
    size: number;
    sortBy: string;
    sortDirection: string;
}
